import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { AuthStore } from '@core/auth/auth.store';

export const permissionGuard: CanActivateFn = (route) => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authStore.user();

  if (!user) {
    return router.createUrlTree(['/login']);
  }

  const requiredPermission = route.data['permission'] as string | undefined;

  if (!requiredPermission) {
    return true;
  }

  const hasPermission = authService.hasPermission(requiredPermission);

  if (hasPermission) {
    return true;
  }

  // Redireciona para início se não tiver permissão
  return router.createUrlTree(['/app/inicio']);
};
